import CreateNewCompany from "./CreateNewCompany";
export default CreateNewCompany